export const nameRegex = /^[0-9a-zäöüß\u0430-\u044f ,.'-]+$/i;
export const numbersOnlyRegex = /^[0-9.]+$/;
export const zipCodeRegex = /^\d{5}(?:-\d{4})?$/;
// Phone formats:
// - Norway: optional country prefix 47 with optional plus, then 7–12 digits
// - Ukraine: +380 followed by 9 digits
export const phoneRegex = /^(?:(?:\+?47)?\d{7,12}|\+380\d{9})$/;
// '+' plus 15 digits — the longest value phoneRegex accepts
export const PHONE_MAX_LENGTH = 16;
export const passwordRegex = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\W)(?=.{8,}$).*$/gm;
export const otpCodeRegex = /^\d{6}$/;

export const emailRegex = /^[\w.-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]+)+$/;

export const urlRegex = /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)/g;
